const buttonState = {
    DEFAULT: 'DEFAULT',
    SAVED: 'SAVED',
};

class ProductSaveToListController {
    constructor($scope, $element, $state, sessionStorage, savedListsService, shopperService, loginService, moveFocus) {
        this.$scope = $scope;
        this.$element = $element;
        this.$state = $state;
        this.sessionStorage = sessionStorage;
        this.savedListsService = savedListsService;
        this.shopperService = shopperService;
        this.loginService = loginService;
        this.moveFocus = moveFocus;

        this.showDropdown = false;
        this.lastSavedList = '';

        this.buttonStates = buttonState;
        this.buttonState = buttonState.DEFAULT;
    }

    $onInit() {
        this.pendingSaveToListStorageKey = `ProductSaveToListController:pendingSaveToList:${this.product.Stockcode}`;

        if (!this.shopperService.IsGuest) {
            this.savedListsService.listSavedLists().then(() => {
                const { stockcode } = this.sessionStorage.getJsonAndRemove(this.pendingSaveToListStorageKey) || {};

                if (stockcode === this.product.Stockcode) {
                    this.save();
                    this.moveFocus(this.$element.find('._saveToListButton'));
                }
            });
        }
    }

    getButtonSrMessage() {
        return this.buttonState === buttonState.SAVED ? `Choose a list to save ${this.product.Name}` : `Save ${this.product.Name} to default list`;
    }

    save() {
        if (!this.savedListsService.isServiceAvailable()) {
            this.showServiceError();
            return;
        }

        if (this.shopperService.IsGuest) {
            this.promptForGuest();
            return;
        }

        if (this.lastSavedList === '') {
            this.saveToList({}, false, true); // save to default list
        } else {
            this.toggleDropdown(true);
        }
    }

    saveToList(list, shouldCloseDropdown, shouldSaveToDefault) {
        if (!this.savedListsService.savedLists || this.savedListsService.savedLists.length === 0) {
            this.savedListsService.listSavedLists().then(() => this.saveToList(list, shouldCloseDropdown, shouldSaveToDefault));
            return;
        }

        if (shouldSaveToDefault) {
            list = this.savedListsService.savedLists[0];
        }

        this.lastSavedList = this.isDefaultList(list.ListId) ? 'Default' : list.Name;
        this.buttonState = buttonState.SAVED;

        this.savedListsService.addToList(list.ListId, this.product.Stockcode, this.product.DisplayQuantity).then(() => {
            this.srMessage = `${this.product.Name} has been saved to ${this.lastSavedList}`;
            this.savedListsService.listSavedLists().finally(() => {
                this.toggleDropdown(shouldCloseDropdown);
            });
        });
    }

    showServiceError() {
        this.showErrorMessage = true;
        this.toggleDropdown(false);
        this.moveFocus(() => this.$element.find('._productSaveToListError'));
    }

    promptForGuest() {
        this.loginService.promptForLogin(this.loginService.LoginToSavetoListMessage, undefined, undefined, { reload: false }, () => {
            this.sessionStorage.setJson(this.pendingSaveToListStorageKey, { stockcode: this.product.Stockcode });
        });
    }

    toggleDropdown(shouldMoveFocus) {
        this.showDropdown = !this.showDropdown;

        if (this.showDropdown) {
            if (shouldMoveFocus) {
                this.moveFocus(() => this.$element.find('.productSaveToList-listItem > label').first());
            }
            $('body').on('click.productSaveToList', e => this.closeDropdownOnOutsideClick(e));
        }
    }

    closeDropdownOnOutsideClick(event) {
        if (!($(event.target).closest('wow-product-save-to-list')[0] === this.$element[0])) {
            this.showDropdown = false;
            this.$scope.$apply();
            $('body').off(event);
        }
    }

    wasLastSavedList(list) {
        if (this.lastSavedList === 'Default') {
            return this.isDefaultList(list.ListId);
        }
        return this.lastSavedList === list.Name;
    }

    isDefaultList(listId) {
        return this.savedListsService.savedLists[0].ListId === listId;
    }

    $onDestroy() {
        $('body').off('click.productSaveToList');
    }
}

const productSaveToListComponentDefinition = {
    bindings: {
        product: '<',
    },
    controller: ['$scope', '$element', '$state', 'SessionStorageWrapper', 'SavedListsService', 'ShopperService', 'LoginService', 'MoveFocus', ProductSaveToListController],
    template: require('./product-save-to-list.component.html').trim(),
};

module.exports = {
    ProductSaveToListController,
    productSaveToListComponentDefinition,
};




// WEBPACK FOOTER //
// ./src/shop/productsavetolist/product-save-to-list.component.js